export default __webpack_public_path__ + "static/media/select-device.cbb9b59a.png";